import React, { useEffect, useState } from "react";
import { Checkbox, Form, FormInstance, Input, Typography } from "antd";
import { ITagForm } from "store/readers-tags/tags/tags-model";
import { validationPlate, validationSpecialCharacters } from "utils/form/validations";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./index.styled";

type LayoutType = Parameters<typeof Form>[0]["layout"];

interface IDispatchProps {
  tagsEventTagActive: (...args) => void;
}

export interface IPropsFormTag {
  form: FormInstance;
  editTag: ITagForm;
  isTagActive: boolean;
}

export type IFormProps = IPropsFormTag & IDispatchProps;

const { Title } = Typography;

const FormTags = ({ form, editTag, isTagActive, tagsEventTagActive }: IFormProps) => {
  const [formLayout, setFormLayout] = useState<LayoutType>("vertical");
  const INVALID_PLATE = useTranslation({ id: "invalid_plate" });
  const FILL_DATA_FOR_THE_TAG = useTranslation({ id: "fill_in_the_data_for_the_tag_below" });

  useEffect(() => {
    if (editTag?.id) {
      form.setFieldsValue(editTag);
    }
  }, [editTag, form]);

  const onFormLayoutChange = ({ layout }: { layout: LayoutType }) => {
    setFormLayout(layout);
  };

  const onChangeActivateEvent = (e) => {
    tagsEventTagActive(e.target.checked);
  };

  const handleKeyDown = (e) => {
    if (!validationSpecialCharacters.test(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <Form style={S.FormLayout} layout={"vertical"} form={form} initialValues={{ layout: formLayout }} onValuesChange={onFormLayoutChange} name="registers">
      <S.Description>{FILL_DATA_FOR_THE_TAG}</S.Description>
      <S.LayoutForm>
        <div className="item">
          <S.FormItem
            name="ievNumber"
            label={`${useTranslation({ id: "iev_number" })}*`}
            hasFeedback
            rules={[
              {
                required: true,
                message: useTranslation({ id: "required_field" }),
              },
            ]}
          >
            <Input style={S.InputDocument} data-testid="ievNumber" disabled />
          </S.FormItem>
          <S.FormItem
            name="tagNumber"
            label={`${useTranslation({ id: "tag_number" })}*`}
            hasFeedback
            rules={[
              {
                required: true,
                message: useTranslation({ id: "required_field" }),
              },
            ]}
          >
            <Input style={S.InputDocument} data-testid="tagNumber" disabled />
          </S.FormItem>
          <S.FormItem
            name="vehiclePlate"
            label={`${useTranslation({ id: "plate" })}`}
            hasFeedback
            getValueFromEvent={(e) => e.target.value.toUpperCase()}
            rules={[
              {
                pattern: validationPlate,
                message: INVALID_PLATE,
              },
            ]}
          >
            <Input
              style={S.PlatesField}
              placeholder={useTranslation({ id: "enter_vehicle_license_plate" })}
              maxLength={7}
              onKeyDown={handleKeyDown}
              data-testid="vehiclePlate"
              disabled={!!editTag.vehiclePlate}
            />
          </S.FormItem>
          <S.FormItem name="locationDescription" label={`${useTranslation({ id: "unit" })}*`} hasFeedback>
            <Input style={S.InputDocument} data-testid="locationDescription" disabled />
          </S.FormItem>
          <S.EventsContainer>
            <div>
              <S.FormCheckbox name="active">
                <Checkbox checked={isTagActive} data-testid="tagActive" onChange={onChangeActivateEvent} />
              </S.FormCheckbox>
              <Title level={5} style={S.CheckDescription}>
                {useTranslation({ id: "active" })}
              </Title>
            </div>
          </S.EventsContainer>
        </div>
      </S.LayoutForm>
    </Form>
  );
};

export default FormTags;
